export interface RequestProductInformationModel {
    productNumber: string;
    productName: string;
    productDescription: string;
    productImage: string;
    productUrl: string;
    productPrice: number;
    lastPurchasedOn: Date;
    previousPurchaseStillValid: boolean;
    canChangeQuantity: boolean;
    isQuoteRequired: boolean;
    availablePaymentMethods: number[];
    customerBalance: number;
}

export interface PurchaseProductResponse {
    status: boolean;
    webOrderNumber: string;
    fullfillmentUrl: string;
}

export interface IOrderMetaPlugin {
    viewTitle: string;
    isValid: () => Promise<boolean>;
    getMetaModel: () => any;
    readonly disableSubmit: boolean;
    readonly canSubmit: boolean;
}

export interface ValidateOrderForInputResponse {
    isValid: boolean;
    redirectUrl: string;
    ruleCollectionId?: number;
    orderPurchaseDate?: Date;
    optimizlyOrderKey: string;
}

export interface GetOrderResponse {
    order: OrderModel;
}

export interface SaveOrderMetaResponse {
    orderGuid: string;
    meta: string;
    modifiedByEmail: string;
}

export interface GetOrderUrlResponse {
    url: string;
    shouldNavigateToProduct: boolean;
}

export interface OrderModel {
    orderGuid: string;
    purchaseDate: string;
    optimizlyOrderKey: string;
    userEmail: string;
    orderStatusId: number;
    product: OrderProductModel;
    orderUrl: string;
}

export interface OrderProductModel {
    productId: number;
    productTypeId: number;
    name: string;
    code: string;
    viewModel: string;
    variantAttributes: { dimension: string, value: string }[];
}

export interface CompRightStoreProductModel {
    name: string;
    description: string;
    tags: string[];
    url: string;
    imageUrl: string;
    isComingSoon: boolean;
    expiry: string;
    showInPlatform: boolean;
}

export interface BudgetClientModel {
    budgetId: number;
    businessUnitId: number;
    paidCredits: number;
    bonusCredits: number;
    activationDate: Date;
    expirationDate: Date;
    usedCredits: number;
    expiredCredits: number;
    remainingCredits: number;
}

export interface RightStoreCheckoutProductInformationModel {
    productNumber: string;
    productName: string;
    productDescription: string;
    productImage: string;
    productUrl: string;
    totalPrice: number;
    lastPurchasedOn: Date;
    previousPurchaseStillValid: boolean;
    canChangeQuantity: boolean;
    isQuoteRequired: boolean;
    availablePaymentMethods: number[];
    customerBalance: number;
}

export interface PurchaseProductResponse {
    status: boolean;
    webOrderNumber: string;
    fullfillmentUrl: string;
}

export enum PaymentTypeEnum {
    RightStoreCredits = 1,
    Invoice = 2,
    CreditCards = 3
}

export enum RightStoreProductTypeEnum { 
    Screening = 1,
    Reports = 2,
    Vet = 3,
    File = 4,
    Subscription = 5,
    PlatformPdf = 6,
    CompanyReportPdf = 7,
    Topup = 8
}

export enum OrderStatusEnum {
    PendingMeta = 1,
    ProcessingOrder = 2,
    Created = 3,
    Fulfilled = 4,
    Canceled = 5,
    Failed = 6
}

export interface RightStoreCheckoutModel {
    customerNumber: number;
    productNumber: string;
    userName: string;
    queryParams: string;
    quantity: number;
    canCustomerInvoice: boolean;
    showCreateOpportunityDialog: boolean;
    preventRedirect: boolean;
    afterPurchase: (fulfillmentUrl: string) => Promise<void>;
}

export interface RightStoreCheckoutPurchaseModel {
    productNumber: string;
    customerNumber: number;
    userName: string;
    queryParams: string;
    checkoutQuantity: number;
    paymentMethod?: number;
    priceOverride?: number;
}

export enum RecordTypeEnum {
    OneoffQuote = 1,
    Contract = 2
}

export interface RecordType {
    recordType: RecordTypeEnum;
    name: string;
}

export const ProductCodes = {
    PscCloseOutFree: "psc-closeout-free",
    PscCloseOutPriority: "psc-closeout-priority",
    IncidentCloseOutFree: "incident-closeout-free",
    IncidentCloseOutPriority: "incident-closeout-priority",
    InformationServiceSubscription: "information-services",
}

export interface GetEntityOrderResponse {
    orderGuid: string;
    priority: boolean;
}
